// extracted by mini-css-extract-plugin
module.exports = {"command":"command--f1H-B","btns":"btns--1LJvg","boxTitle":"boxTitle--3y-Lw","info":"info--3QGT3","high":"high--2BPZe"};